module.exports = {
  WEBDRIVERIO_INPUT_NAVIGATION_BUTTONS: ['>>> .bot-animation'],
  WEBDRIVERIO_INPUT_ELEMENT: '>>> .input-box-wrapper input',
  WEBDRIVERIO_OUTPUT_ELEMENT: '>>> #messageList .bot-message:not(#typing), #messageList df-card',
  WEBDRIVERIO_OUTPUT_ELEMENT_BUTTONS: '>>> df-button a',
  WEBDRIVERIO_OUTPUT_ELEMENT_EXTRA_BUTTONS: '>>> .df-chips-wrapper:not(.clicked) a'
}
